import { IconName } from '@amobee/component-library';
import { Component, Input } from '@angular/core';

export interface TableToolBarAdditionalButton {
    icon: IconName;
    isDisabled?: boolean;
    onClick: () => void;
    title?: string;
}

@Component({
    selector: 'table-toolbar-button-wrapper',
    templateUrl: './table-toolbar-button-wrapper.component.html',
    styleUrls: ['./table-toolbar-button-wrapper.component.scss']
})
export class TableToolbarButtonWrapperComponent {
    @Input() public hide: boolean;
    @Input() public additionalButtons?: TableToolBarAdditionalButton[] = [];
}